import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
class GetUserAlertsFilteredProvincesUseCase extends UseCase {
  constructor({getUserAlertsFilteredProvincesService, userAlertIdValueObject}) {
    super()
    this._getUserAlertsFilteredProvincesService = getUserAlertsFilteredProvincesService
    this._userAlertIdValueObject = userAlertIdValueObject
  }

  /**
   * @return {Promise<Object, Error>}
   */
  @tracer({metric: 'GetUserAlertsFilteredProvincesUseCase#execute'})
  @inlineError
  async execute({alertId}) {
    const userAlertIdValueObject = this._userAlertIdValueObject({alertId})

    const [getUserAlertsFilteredProvincesError, getUserAlertsFilteredProvincesResponse] =
      await this._getUserAlertsFilteredProvincesService.execute({
        userAlertIdValueObject
      })

    if (getUserAlertsFilteredProvincesError) return Promise.reject(getUserAlertsFilteredProvincesError)

    return getUserAlertsFilteredProvincesResponse.getFilteredProvinces()
  }
}

export default GetUserAlertsFilteredProvincesUseCase
